<template>
  <div class="accordion">
    <ul class="list-unstyled">
      <slot />
    </ul>
  </div>
</template>

<script setup>
import { provide, ref } from 'vue';

const props = defineProps({
  openMultiple: {
    type: Boolean,
    default: true,
  },
});

const openItems = ref([]);

function toggleItem(title) {
  const index = openItems.value.indexOf(title);
  const isOpen = index !== -1;

  if (props.openMultiple) {
    if (isOpen) {
      openItems.value.splice(index, 1);
    } else {
      openItems.value.push(title);
    }
  } else {
    // always holds a single item
    openItems.value = isOpen ? [] : [title];
  }
}

function isOpenItem(title) {
  return openItems.value.includes(title);
}

provide('accordion', {
  isOpenItem,
  toggleItem,
});
</script>
